import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { FusService } from '../../../services/formulacion/fus.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-seg-fus',
  templateUrl: './seg-fus.component.html',
  styleUrls: [],
  providers: [FusService]
})
export class SegFusComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  fuses: any[];
  baseUrl = environment.apiEndpoint;
  baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
  fusSeg: string = '';
  popupVisibleSeg: boolean = false;
  dataSeg: any = [];

  constructor(private _fs: FusService) {
    this.getListFus();
  }

  ngOnInit() {
  }

  getListFus() {
    this._fs.getListPptoSegFus().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        console.log (':', result.data);
        if (result.status == 200) { this.fuses = result.data; }
        else { this.fuses = []; }
      },
      (error) => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      widget: 'dxButton',
      options: {
        icon: 'refresh',
        text: 'Actualizar',
        onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid(e) {
    this.getListFus();
    this.dataGrid.instance.refresh();
  }

  showModalSeg(id: string, fus: string) {
    this.fusSeg = fus;
    this._fs.getSeguimientoByFusId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.dataSeg = result.data; }
      },
      (error) => { console.log('Error', error); });
    this.popupVisibleSeg = true;
  }
}
